import { render, staticRenderFns } from "./BasicText.vue?vue&type=template&id=7bbd411c&"
import script from "./BasicText.vue?vue&type=script&lang=ts&"
export * from "./BasicText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports